// extracted by mini-css-extract-plugin
module.exports = {"icon":"_snackbars_icon__Z7uYP","dismissIcon":"_snackbars_dismissIcon__2EUmP","notifications":"_snackbars_notifications__3og7D"};